export default __webpack_public_path__ + "static/media/sidebar-3.c3071ade.png";